import { KeyBooleanPair } from './base';

export class User {
  Email: string;
  FamilyName: string;
  GivenName: string;
  Username: string;
  UserId: string;
  LegacyUserId: string;
  Roles: string[];
  Permissions: Record<string, Record<string, string>>; // permission: [access_levels]
}

export class Role {
  Id: string;
  Name: string;
  Description: string;
  RoleName: string;
}

// general structure to handle simple user preferences across portals
// more complex structures should be designed and stored separately
export class UserPreferences {
  ClientPrefs: {
    [key: string]: ClientPreferences;
  };

  constructor() {
    this.ClientPrefs = {};
  }
}

// structure to handle client specific preferences
// Payroll specific keys should be added as properties under Payroll
export class ClientPreferences {
  Payroll: {
    SortEmployeeByLastName?: boolean;
    ColumnVisibility?: KeyBooleanPair[]; // colId, visible
  };
}
